/**
 * Auth Guard
 * Компонент для защиты маршрутов от неавторизованных пользователей
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'shared/context/AuthContext';

/**
 * Компонент для защиты маршрутов
 * Показывает loader во время загрузки сессии
 * Редирект на login если не авторизован
 */
export function AuthGuard({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  console.log('[AuthGuard] Path:', location.pathname, '| isLoading:', isLoading, '| isAuthenticated:', isAuthenticated);

  if (isLoading) {
    // Показать loader во время инициализации сессии
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('[AuthGuard] Not authenticated, redirecting to login');
    // Редирект на страницу входа
    return <Navigate to="/login" replace />;
  }

  // Отобразить защищённый контент
  return <>{children}</>;
}
